import styled from 'styled-components';

export const Wrapper = styled.div`
    padding: 16px 0;
`;

export const Content = styled.div``;

export const Item = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
`;

export const Index = styled.div`
    flex: 60px 0 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const Config = styled.div`
    flex: 500px 0 0;
    padding: 16px;
    background-color: rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: stretch;
    gap: 10px;
`;

export const Action = styled.div``;

export const Label = styled.div``;

export const Remove = styled.div``;

export const Add = styled.div``;
